import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import Table, { TableColumn } from "../../../../../../components/Table";
import { AnticipationResultModalProps, SimulationResponse } from "../../types";
import {
  formatMoney,
  formatTotal,
} from "../../../../../../utils/generalFormat";
import { Button, ValueCard } from "../../../../../contractEffects/styles";
import AnticipationService from "../../service/AnticipationService";
import {
  ConfirmButton,
  GhostButton,
  ModalActions,
  TableContainerAnticipation,
} from "../../../../styles";
import { toast } from "react-toastify";
import LoadingOverlay from "../../../../../../components/LoadingOverlay";

export const AnticipationResultModal: React.FC<
  AnticipationResultModalProps
> = ({ isShowingResult, onClose, onConfirmed, data }) => {
  if (!data) return null;

  const [simulationResult, setSimulationResult] =
    React.useState<SimulationResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const antecipationService = new AnticipationService();
  const saveFile = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const fetchSimulation = async () => {
    setIsLoading(true);
    try {
      const response = await antecipationService.simulateAnticipation(data);
      setSimulationResult(response);
    } catch (error) {
      console.error("Erro ao carregar simulação:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadPdf = async () => {
    try {
      setIsLoading(true);
      const response = await antecipationService.downloadAnticipationPdf(data);
      if (!response) return;
      const blob =
        response instanceof Blob
          ? response
          : new Blob([response], { type: "application/pdf" });
      saveFile(blob, "RelatorioAntecipação.pdf");
    } catch (error) {
      console.error("Erro ao baixar PDF Antecipação:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadFomenti = async () => {
    setIsLoading(true);
    const response = await antecipationService.downloadAnticipationFomenti(
      data
    );

    try {
      if (response) {
        const objectUrl = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = "Modelo de Importação - Fomenti.xlsx"; // Nome do arquivo
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      }
    } catch (error) {
      console.log("Erro ao baixar a planilha: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      const response = await antecipationService.confirmAnticipation(data);

      if (response) {
        toast.success("Antecipação confirmada com sucesso!");
        onConfirmed();
        onClose();
      } else {
        toast.error(
          `Erro ao confirmar: ${response?.message ?? "Tente novamente."}`
        );
      }
    } catch (error) {
      console.error("Erro ao confirmar antecipação:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isShowingResult) return;

    fetchSimulation();
  }, [data]);

  return (
    <Modal
      title="Simulação de Antecipação"
      open={isShowingResult}
      onCancel={onClose}
      footer={null}
      width="98%"
      style={{
        top: 20,
        maxWidth: "98vw",
      }}
      bodyStyle={{
        maxHeight: "98vh",
        overflowY: "auto",
      }}
    >
      <LoadingOverlay show={isLoading} relative />

      <div style={{ display: "flex", justifyItems: "left", marginBottom: 20 }}>
        <ValueCard style={{ display: "flex", gap: 3 }}>
          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Valor Bruto Original:</p>
            <p>{formatTotal(data.totalGrossValue ?? 0)}</p>
          </div>

          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Valor Líquido Original:</p>
            <p>{formatTotal(data.totalLiquidValue ?? 0)}</p>
          </div>

          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Valor Líquido Final:</p>
            <p>{formatTotal(simulationResult?.finalLiquidValue ?? 0)}</p>
          </div>

          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Prazo médio:</p>
            <p>{simulationResult?.averageTime ?? 0} Dias</p>
          </div>
          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Total Fator de Compra:</p>
            <p>
              {formatTotal(simulationResult?.totalPurchasingFactorValue ?? 0)}
            </p>
          </div>
          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Total AdValorem:</p>
            <p>{formatTotal(simulationResult?.totalAdValoremValue ?? 0)}</p>
          </div>
          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Total IOF:</p>
            <p>{formatTotal(simulationResult?.totalIofValue ?? 0)}</p>
          </div>
          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Total Taxas e Tarifas:</p>
            <p>{formatTotal(simulationResult?.totalTariffValue ?? 0)}</p>
          </div>
          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Total Recompra:</p>
            <p>{formatTotal(simulationResult?.totalRebuyValue ?? 0)}</p>
          </div>
          <div style={{ height: "100px", width: "220px" }}>
            <p style={{ fontWeight: "bolder" }}>Outros acréscimos/descontos:</p>
            <p>{formatTotal(simulationResult?.totalOtherValue ?? 0)}</p>
          </div>
        </ValueCard>
      </div>

      <div style={{ display: "flex", gap: "16px", marginBottom: "20px" }}>
        <Button onClick={handleDownloadPdf} style={{ width: "230px" }}>
          Download PDF Simulação
        </Button>
        <Button onClick={handleDownloadFomenti} style={{ width: "230px" }}>
          Download Fomenti
        </Button>
      </div>

      <TableContainerAnticipation>
        <Table dataSource={simulationResult?.records ?? []}>
          <TableColumn
            title="AdValorem"
            dataIndex="adValoremValue"
            key="adValoremValue"
            render={formatMoney}
          />
          <TableColumn
            title="Dias Antecipados"
            dataIndex="anticipatedDays"
            key="anticipatedDays"
          />
          <TableColumn
            title="Autorização"
            dataIndex="authorization"
            key="authorization"
          />
          <TableColumn
            title="Parcela Atual"
            dataIndex="currentParcel"
            key="currentParcel"
          />
          <TableColumn title="Documento" dataIndex="document" key="document" />
          <TableColumn title="Sacado" dataIndex="drawee" key="drawee" />
          <TableColumn
            title="Taxa de Antecipação"
            dataIndex="feesValue"
            key="feesValue"
            render={formatMoney}
          />
          <TableColumn
            title="Valor Liquido Original"
            dataIndex="grossValue"
            key="grossValue"
            render={formatMoney}
          />
          <TableColumn
            title="ID Comerciante"
            dataIndex="merchantId"
            key="merchantId"
          />
          <TableColumn
            title="Valor Líquido Final"
            dataIndex="newLiquidValue"
            key="newLiquidValue"
            render={formatMoney}
          />
          <TableColumn
            title="Nova Data Recebimento"
            dataIndex="newReceiveDate"
            key="newReceiveDate"
            render={(date: string) =>
              new Date(date).toLocaleDateString("pt-BR")
            }
          />
          <TableColumn title="NSU" dataIndex="nsu" key="nsu" />
          <TableColumn title="Número" dataIndex="number" key="number" />
          <TableColumn
            title="Valor Bruto original Original"
            dataIndex="originalValue"
            key="originalValue"
            render={formatMoney}
          />
          <TableColumn
            title="Data Pagamento"
            dataIndex="paymentDate"
            key="paymentDate"
            render={(date: string) =>
              new Date(date).toLocaleDateString("pt-BR")
            }
          />
          <TableColumn
            title="Fator de Compra"
            dataIndex="purchasingFactorValue"
            key="purchasingFactorValue"
          />
          <TableColumn
            title="Data Recebimento"
            dataIndex="receiveDate"
            key="receiveDate"
            render={(date: string) =>
              new Date(date).toLocaleDateString("pt-BR")
            }
          />
          <TableColumn
            title="Tarifa"
            dataIndex="tariffValue"
            key="tariffValue"
            render={formatMoney}
          />
          <TableColumn
            title="Taxa de Imposto"
            dataIndex="taxValue"
            key="taxValue"
            render={formatMoney}
          />
          <TableColumn
            title="Título"
            dataIndex="titleNumber"
            key="titleNumber"
          />
          <TableColumn
            title="Taxa IOF"
            dataIndex="totalIofValue"
            key="totalIofValue"
            render={formatMoney}
          />
          <TableColumn title="Tipo" dataIndex="type" key="type" />
        </Table>
      </TableContainerAnticipation>

      <ModalActions>
        <ConfirmButton onClick={handleConfirm}>
          Confirmar Antecipação
        </ConfirmButton>
      </ModalActions>
    </Modal>
  );
};
